export const INTERVIEW_PATH = "/interviews/:interviewId";
